<template>
    <div class="bo-category">
        <div class="categories" v-for="category in categories" :key="category.index">
            <div v-if="category.parent_id == 0">
                <a :href="categoryPageUrl + '/category/' + category.id + '#catalog-list'" class="d-flex">
                    <div class="category">
                        <div class="total-items">
                            {{ category.product_count }} products
                        </div>
                        <div class="name theme-primary-color">
                            {{ category.name }}
                        </div>
                    </div>
                    <i class="icon-chevronright"></i>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import categoriesMixin from "@/v2/mixins/product-categories.js";

export default {
    mixins: [categoriesMixin],
    props: {
        categoryUrl: {
            type: String,
        },
        categoryPageUrl: {
            type: String,
        },
    },
    data() {
        return {
            categories: null,
        }
    },
    mounted() {
        this.fetchCategories();
    },
    methods: {
        loadCategories(payload, success, failure) {
            this.categories = [];
            payload = {
                params: {
                    limit: 50,
                },
            };

            this.getProductCategories(this.categoryUrl, payload, (categories, pagination) => {
                categories.forEach((category) => {
                    if (category.parent_id == 0) {
                        this.categories.push(category);
                    }
                });
            });
        },
        fetchCategories(payload = null, success = null, failure = null) {
            this.loadCategories(payload, success, failure);
        },
    },
};
</script>
